import { render } from 'preact';
import { App } from './app';
import './styles.css';
import './install';

render(<App />, document.getElementById('app')!);

// Offline support (production only; the dev server serves modules that must not be cached).
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => undefined));
}
